import { isShipmentDeleted } from './shipmentDeleted.js'

export const SHIPMENT_EDIT_FIELD_LABELS = {
  sender_name: 'Sender name',
  sender_address: 'Sender address',
  sender_contact: 'Sender contact',
  sender_email: 'Sender email',
  receiver_name: 'Receiver name',
  receiver_address: 'Receiver address',
  receiver_contact: 'Receiver contact',
  receiver_email: 'Receiver email',
  receiver_location: 'To destination',
  consignee_location: 'To destination',
  receiver_location_hub_id: 'To branch',
  mode_of_payment: 'Payment status',
  payment_mode: 'Payment mode',
  paid_amount: 'Paid amount',
  shipment_client_id: 'Credit client',
  parcels: 'Articles / parcels',
  invoice_number: 'Invoice number',
  invoice_value: 'Invoice value',
}

const FORM_TO_SNAPSHOT = {
  sender_name: 'consigner_name',
  sender_address: 'consigner_address',
  sender_contact: 'consigner_contact',
  sender_email: 'consigner_email',
  receiver_name: 'consignee_name',
  receiver_address: 'consignee_address',
  receiver_contact: 'consignee_contact',
  receiver_email: 'consignee_email',
  receiver_location: 'consignee_location',
  consignee_location: 'consignee_location',
  receiver_location_hub_id: 'receiver_location_hub_id',
  mode_of_payment: 'mode_of_payment',
  payment_mode: 'payment_mode',
  paid_amount: 'paid_amount',
  shipment_client_id: 'shipment_client_id',
}

const REQUEST_EXCLUDE_FIELDS = new Set([
  'paid_amount',
  'balance_amount',
  'total_amount',
])

export const buildAgentProposedFromEditForm = (formData, allowedFields = []) => {
  const proposed = {}
  ;(allowedFields || []).forEach((key) => {
    if (REQUEST_EXCLUDE_FIELDS.has(key)) return
    const formKey = FORM_TO_SNAPSHOT[key] || key
    if (formData[formKey] !== undefined) {
      proposed[key] = formData[formKey]
    } else if (formData[key] !== undefined) {
      proposed[key] = formData[key]
    }
  })
  return proposed
}

export const canAgentRequestShipmentEdit = (shipment, user) => {
  if (user?.role !== 'Agent') return false
  if (!shipment || isShipmentDeleted(shipment)) return false
  if (String(shipment.status || '').toLowerCase() === 'delivered') return false
  return true
}

export const formatSnapshotValue = (key, value) => {
  if (value == null || value === '') return '—'
  if (key === 'receiver_location_hub_id') return String(value)
  if (key === 'parcels' && Array.isArray(value)) {
    return value.length
      ? `${value.length} article(s)`
      : '—'
  }
  return String(value)
}
